import "./toast.scss";

export default function Toast({ show, message }) {
    if (!show) return null;

    return (
        <div className="toast-wrap d-f ai-c jc-c p-a l-0 w-100">
            <div className="ta-c fs-2 py-3 px-5 d-if ws-nw">{message}</div>
        </div>
    );
}